import React from 'react';
import CurrencyColumn from '../../../components/columns/currency-column';
import { FormattedMessage } from 'react-intl';

export const OrderTotal = {
  getName: () => <FormattedMessage defaultMessage='Total' description='customersOrdersGrid.columns.orderTotal' id='SEqEUc' />,
  id: 'orderTotal',

  render: (data) => {
    let total = {
      code: 'USD',
      value: 0,
    };
    const { amountSummary = {} } = data || {};
    if (amountSummary) {
      total = amountSummary.orderTotal || total;
    }
    const { code, value } = total;
    return <CurrencyColumn currencyCode={code} overideStyle value={value} />;
  },
};
